const STORAGE_KEY = 'plp-media-view';
const HTML_ATTR = 'data-media-view';
const SYNC_EVENT = 'mediaViewChange';

class MediaViewToggle extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
    document.addEventListener(SYNC_EVENT, this.#handleSyncEvent);

    const view = this.#resolveView();
    document.documentElement.setAttribute(HTML_ATTR, view);
    this.#updateButtons(view);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
    document.removeEventListener(SYNC_EVENT, this.#handleSyncEvent);
  }

  #handleClick = (event) => {
    const btn = event.target.closest('[data-view]');
    if (!btn) return;

    const view = btn.dataset.view;
    if (view !== 'room' && view !== 'product') return;

    sessionStorage.setItem(STORAGE_KEY, view);
    document.documentElement.setAttribute(HTML_ATTR, view);
    this.#updateButtons(view);

    // Keep the other instance (desktop vs mobile bar) in sync
    document.dispatchEvent(new CustomEvent(SYNC_EVENT, { detail: { view } }));
  };

  #handleSyncEvent = (event) => {
    if (event.detail?.view) this.#updateButtons(event.detail.view);
  };

  /**
   * Schema default from the filters block. Product matches the previous hardcoded toggle.
   * @returns {'room' | 'product'}
   */
  #defaultView() {
    const value = this.dataset.defaultView;
    return value === 'room' ? 'room' : 'product';
  }

  /**
   * Theme editor follows the schema setting. The storefront keeps a visit choice in sessionStorage.
   * @returns {'room' | 'product'}
   */
  #resolveView() {
    if (window.Shopify?.designMode) return this.#defaultView();

    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored === 'room' || stored === 'product') return stored;

    return this.#defaultView();
  }

  #updateButtons(view) {
    this.querySelectorAll('[data-view]').forEach((btn) => {
      const active = btn.dataset.view === view;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.classList.toggle('media-view-toggle__btn--active', active);
    });
  }
}

if (!customElements.get('media-view-toggle')) {
  customElements.define('media-view-toggle', MediaViewToggle);
}
